export const trainHomeCn = {
    mainfei:"免费",
    kechengjiage:"课程价格",
    kechengjieshu:"课程节数",
    bofangliang:"播放量",
    zongshichang:"总时长",
    vipFree:"VIP免费观看",
    goumaikecheng:"购买课程",
    lijibofang:"立即播放",
    fenxiang:"分享",
    peixunxiangqing:"培训详情",
    peixunpinglun:"培训评论",
    guankanwangzhengsp:'观看完整视频'
}


// WEBPACK FOOTER //
// ./src/lang/home/trainHome/indexCn.js